import React, { useState } from "react";
import style from "./styles.module.scss";
import { Table, Button, Row, Col, Input } from "reactstrap";
import { Combobox, Field } from "../../Order/Field/Field";
import { Mode } from "../../../Asset/types";
import { BookTypes } from "../../../../utils/Helper";

const emptyItem = {
  currencyId: null,
  currencyISO: "",
  currencyNumber: "",
  imputableAccountId: null,
  imputableAccountName: "",
};

const CurrencyList = ({ onChange, loadings, items, currencies, imputableAccounts }) => {
  const [edit, setEdit] = useState({
    open: false,
    mode: Mode.Insert,
    fields: {},
    errors: {},
  });

  const openEdit = (item) => {
    if (item) {
      setEdit({
        open: true,
        mode: Mode.Update,
        fields: { ...item },
        errors: {},
      });
    } else {
      setEdit({
        open: true,
        mode: Mode.Insert,
        fields: { ...emptyItem },
        errors: {},
      });
    }
  };

  const closeEdit = ({ confirm }) => {
    if (confirm) {
      const errors = validate(edit, items);

      if (Object.keys(errors).length === 0) {
        if (edit.mode === Mode.Insert) {
          handleAction(Mode.Insert);
        } else {
          handleAction(Mode.Update);
        }
      } else {
        setEdit({ ...edit, errors });
        return;
      }
    }

    setEdit({});
  };

  const handleAction = (action, item) => {
    if (action === Mode.Delete) {
      let deletedItem = {
        ...item,
      };
      deletedItem.imputableAccountId = "";
      deletedItem.currencyNumber = "";
      deletedItem.imputableAccountId = "";
      deletedItem.imputableAccountName = "";

      onChange({
        currencyAccounts: items.map((it) => {
          if (item.currencyId == it.currencyId && item.bookType == it.bookType) {
            return deletedItem;
          }
          return it;
        }),
      });
    } else {
      const imputableAccount = imputableAccounts.find((e) => e.id == edit.fields.imputableAccountId) || {};
      const currency = currencies.find((e) => e.currencyId == edit.fields.currencyId);
      const nextFields = {
        ...edit.fields,
        imputableAccountName: imputableAccount.name,
        currencyISO: currency.currencyISO,
      };
      if (action === Mode.Insert) {
        onChange({ currencyAccounts: [...items, nextFields] });
      } else if (action === Mode.Update) {
        onChange({
          currencyAccounts: items.map((item) => {
            if (item.currencyId == edit.fields.currencyId && item.bookType == edit.fields.bookType) {
              return nextFields;
            }
            return item;
          }),
        });
      }
    }
  };

  const handleOnChangeEdit = (fields) => {
    setEdit({ ...edit, fields: { ...edit.fields, ...fields } });
  };

  if (loadings.imputableAccounts || loadings.currencies) {
    return null;
  }

  return (
    <div>
      <div className="text-right">
        <Button color="primary" size="sm" className="mb-2" onClick={() => openEdit()} disabled={!!edit.open}>
          <i className="fa fa-plus mr-2" />
          Add new
        </Button>
      </div>
      {edit.open && (
        <Edit
          mode={edit.mode}
          item={edit.fields}
          errors={edit.errors}
          currencies={currencies}
          imputableAccounts={imputableAccounts}
          onChange={handleOnChangeEdit}
          toggle={closeEdit}
        />
      )}
      {!edit.open && (
        <div className={style.table}>
          <Table responsive striped>
            <thead>
              <tr>
                <th>Currency</th>
                <th>Currency number</th>
                <th>Book type</th>
                <th>Imputable Account</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items
                .map((item, index) => {

                  return (
                    <tr key={`item-${item.currencyId}-${index}`}>
                      <td>{item.currencyISO}</td>
                      <td>{item.currencyNumber}</td>
                      <td>{item.bookType}</td>
                      <td>{item.imputableAccountName}</td>
                      <td style={{ minWidth: 80 }}>
                        <Button color="btn-outline-primary btn-sm" onClick={() => openEdit(item)}>
                          <i className="fa fa-pencil" />
                        </Button>
                        <Button
                          color="btn-outline-primary btn-sm"
                          style={{ color: "#d83737" }}
                          onClick={() => handleAction(Mode.Delete, item)}
                        >
                          <i className="fa fa-trash" />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

const Edit = ({ mode, item, errors, currencies, imputableAccounts, onChange, toggle }) => {
  const filterImputableAccounts = (imputableAccounts, currencySelectedISO) => {
    return imputableAccounts.filter((account) => account.currencyIso === currencySelectedISO);
  };
  

  return (
    <div className={style.edit}>
      <span className="d-block text-primary mb-3" style={{ fontWeight: 500 }}>
        {mode === Mode.Insert ? "Adding new row" : "Editing row"}
      </span>
      <Row>
        <Col lg="5">
          <Field label="Currency" error={errors.currencyId}>
            <Combobox
              style={{ marginRight: "8px", fontWeight: 500 }}
              value={item.currencyId}
              disabled={mode === Mode.Update}
              invalid={!!errors.currencyId}
              onChange={(v) => {
                const currencySelected = currencies.find((currency) => currency.currencyId === v);
                onChange({
                  currencyId: v,
                  currencyISO: currencySelected ? currencySelected.currencyISO : "",
                });
              }}
              items={Object.values(currencies).map((k) => ({
                id: k.currencyId,
                description: k.currencyISO,
              }))}
            />
          </Field>
          <Field label={"Account Code"} error={errors.currencyNumber}>
            <Input
              type={"text"}
              placeholder={"Account Code"}
              value={item.currencyNumber || ""}
              invalid={errors.currencyNumber}
              onChange={(e) => onChange({ currencyNumber: e.target.value })}
            />
          </Field>
        </Col>
        <Col lg="7">
          <Field label="Imputable account">
            <Combobox
              style={{ background: "#edf9ff", fontWeight: 500 }}
              value={item.imputableAccountId || ""}
              onChange={(v) => onChange({ imputableAccountId: v })}
              emptyLabel="Not selected"
              items={[{id : '', description:"Not selected"}, ...filterImputableAccounts(imputableAccounts, item.currencyISO).map((key) => ({
                id: key.id,
                description: key.name,
              }))]}
            />
          </Field>
          <Field label="Book type" error={errors.bookType}>
            <Combobox
              style={{ background: "#edf9ff", fontWeight: 500 }}
              value={item.bookType}
              onChange={(v) => onChange({ bookType: v })}
              emptyLabel="Not selected"
              items={Object.keys(BookTypes).map((key) => ({
                id: BookTypes[key],
                description: BookTypes[key],
              }))}
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <Col lg="7">
          <div className={style.buttons}>
            <Button size="sm" color="light" className="mr-2" onClick={() => toggle({})}>
              Cancel
            </Button>
            <Button size="sm" color="primary" onClick={() => toggle({ confirm: true })}>
              Confirm
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

function validate(edit, allItems) {
  const errors = {};
  const { fields, mode } = edit;

  if (fields.currencyId == "" || !fields.currencyId) {
    errors.currencyId = "Required field";
  }

  if (fields.bookType == "" || !fields.bookType){
    errors.bookType = "Required field";
  }


  if (mode === Mode.Insert) {
    if (allItems.some((e) => e.currencyId == fields.currencyId && e.bookType == fields.bookType)) {
      errors.currencyId = "Already exists record with this currency";
      errors.bookType = "Already exists record with this book type";
    }
  }

  return errors;
}

export default CurrencyList;
